<script setup lang="ts">
  import { onMounted } from 'vue';
  import { delegate, Placement, roundArrow } from 'tippy.js';

  const setUpContextTippies = () => {
    delegate('body', {
      target: '[data-tippy-context]',
      arrow: roundArrow,
      animation: 'scale',
      theme: 'context',
      appendTo: () => document.body,
      onMount(instance) {
        instance.popperInstance?.setOptions({
          placement: instance.reference.getAttribute('data-placement') as Placement,
        });
      },
      onShow(instance) {
        if (instance.reference.getAttribute('data-tippy-context') === 'false') return false;
      },
    });
  };

  onMounted(() => {
    setUpContextTippies();
  });
</script>

<template>
  <main class="relative overflow-hidden">
    <div class="flex flex-col items-center justify-center">
      <div class="relative w-full px-6 overflow-visible">
        <slot />
      </div>
    </div>
  </main>
</template>
